import { postSegment } from '@gonfalon/openapi/operations/postSegment';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { segments } from '../queries/segments';

export const useCreateSegment = createMutationHook(postSegment, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: segments.list._def });
  },
});
